import { getState } from "../store";

export const link = (to) => {
    const { userLogin: { userInfo } } = getState();
    return userInfo?.email ? userInfo?.active ? to ?? window.location.pathname : "/verifyEmail" : "/login";
}